<template>
  <payment-link-layout :hideSecurityWarningOnMobile="false" v-if="onboarding">
    <template v-slot:content v-if="hiddenPhone">
      <step-progress-bar
        class="mt-24"
        stepTitle="verificação do celular"
        :stepNumber="3"
        :stepSize="4"
      />

      <onboarding-confirmation-token
        v-if="isMobile"
        :hiddenPhone="hiddenPhone"
        :verifyStatus="verifyStatus"
        @backspace="handleBackspace"
        @completedVerificationCode="completedVerificationCode"
      />

      <onboarding-confirmation-link
        v-else
        class="mb-36"
        :hiddenPhone="hiddenPhone"
      />
    </template>
  </payment-link-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PaymentLinkLayout from '../../paymentLink/layout/PaymentLinkLayout.vue';
import OnboardingConfirmationLink from '../components/OnboardingConfirmationLink.vue';
import OnboardingConfirmationToken from '../components/OnboardingConfirmationToken.vue';
import StepProgressBar from '../../paymentLink/components/StepProgressBar.vue';

export default {
  name: 'v2-onboarding-confirmation',
  components: {
    PaymentLinkLayout,
    StepProgressBar,
    OnboardingConfirmationLink,
    OnboardingConfirmationToken,
  },
  computed: {
    ...mapState('onboardingV2', ['isMobile', 'hiddenPhone', 'nextRoute', 'onboarding']),
  },
  data: () => ({
    verifyStatus: null,
  }),
  methods: {
    ...mapActions('onboardingV2', ['resendConfirmation', 'sendConfirmationCode']),
    async completedVerificationCode(securityCode) {
      this.verifyStatus = 'loading';

      const { success } = await this.sendConfirmationCode({ securityCode });
      this.verifyStatus = success ? 'success' : 'failure';

      if (success) {
        setTimeout(async () => {
          await this.$router.replace({
            name: this.nextRoute,
            query: this.$route.query,
          });
        }, 1000);
      }
    },
    handleBackspace() {
      this.verifyStatus = null;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';
</style>
